import React from 'react';
import styled from 'styled-components';
import { SelectionTitle } from '../../../Styles';

const Wrapper = styled.div`
  margin-top: 25px;
  padding: 0 25px;

  .firmness-container {
    margin-top: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;

    /* button:last-of-type {
      grid-column: span 2;
    } */
  }
`;


function Firmness({
  firmnessId,
  availableFirmnesses,
  productData,
  setProductVar,
  frameId
}) {
  const handleProductVar = firmnessId => {
    setProductVar({
      frame_id: productData.frame.id,

      firmness_id: firmnessId,

      ...(productData.fabric && {
        fabric_id: productData.fabric.id
      }),
      ...(productData.constructionType && {
        construction_type_id: productData.constructionType.id
      }),
      ...(productData.frame.size && {
        size_id: productData.frame.size.id
      }),
      ...(productData.leg && {
        leg_id: productData.leg.id
      }),
      ...(productData.casterLeg && {
        caster_leg_id: productData.casterLeg.id
      }),
      ...(productData.frame.has_assembly_options && {
        is_assembled: productData.is_assembled
      }),
      ...(productData.frame.has_set_of_two && {
        supplier_quantity: productData.supplier_quantity
      }),
      ...(productData.frame.has_wallpaper_types && {
        wallpaper_type: productData.wallpaper_type
      })
    });
  };

  return (
    <Wrapper>
      <SelectionTitle>Select Firmness</SelectionTitle>
      <div className="firmness-container">
        {availableFirmnesses.map((firmnessItem, i) => {
            return (
              <FirmnessButton
                key={`${firmnessItem.id}-${firmnessItem.is_available_on_pdp}`}
                onClick={() => {
                  handleProductVar(firmnessItem.id);
                }}
                index={i}
                selected={firmnessId === firmnessItem.id}
              >
                {firmnessItem.name}
              </FirmnessButton>
            );
          })}
      </div>
    </Wrapper>
  );
}

export default Firmness;

const FirmnessButton = styled.button`
  border: ${({ selected, theme }) =>
    selected ? `3px solid ${(theme.old ? '#2A5CAF' : theme.colors.french)}` : '1px solid black;'};
  height: 50px;
  width: 100%;
  background: ${({ disabled }) =>
    disabled
      ? `linear-gradient(to top left,
             rgba(0,0,0,0) 0%,
             rgba(0,0,0,0) calc(50% - 0.8px),
             rgba(0,0,0,1) 50%,
             rgba(0,0,0,0) calc(50% + 0.8px),
             rgba(0,0,0,0) 100%)`
      : 'white'};

  background-color: ${({ disabled }) => (disabled ? '#f8f8f8' : 'transparent')};
  grid-column: ${({ index }) => (index === 4 ? 'span 2' : 'span 1')};

  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? '0.8' : '1')};

  &:hover {
    outline: none;
  }
`;
